import store from "../store";
import imgContrib1tconsumo from "../assets/images/icone-contributi/cont-01-consumo.svg";
// import imgContrib2tconsumo from "../assets/images/icone-contributi/cont-02-consumo.svg";
import imgContrib3tconsumo from "../assets/images/icone-contributi/cont-03-consumo.svg";
import imgContrib4crescita from "../assets/images/icone-contributi/cont-04-crescita.svg";
import imgContrib4pari from "../assets/images/icone-contributi/cont-04-pari.svg";
import imgContrib5 from "../assets/images/icone-contributi/cont-05.svg";
// import imgContrib6 from "../assets/images/icone-contributi/cont-06.svg";
// import imgContrib7salute from "../assets/images/icone-contributi/cont-07-salute.svg";
// import imgContrib7crescita from "../assets/images/icone-contributi/cont-07-crescita.svg";
import imgContrib8crescita from "../assets/images/icone-contributi/cont-08-crescita.svg";
import imgContrib8pari from "../assets/images/icone-contributi/cont-08-pari.svg";
import imgContrib9 from "../assets/images/icone-contributi/cont-09.svg";
import imgContrib9consumo from "../assets/images/icone-contributi/cont-09-consumo.svg";
import imgContrib10crescita from "../assets/images/icone-contributi/cont-10-crescita.svg";
// import imgContrib10salute from "../assets/images/icone-contributi/cont-10-salute.svg";

import imgSdg3Full from "../assets/images/icone-sdg/1-sdg-full@2x.png";
import imgSdg4Full from "../assets/images/icone-sdg/2-sdg-full@2x.png";
import imgSdg5Full from "../assets/images/icone-sdg/3-sdg-full@2x.png";
import imgSdg6Full from "../assets/images/icone-sdg/4-sdg-full@2x.png";
import imgSdg7Full from "../assets/images/icone-sdg/5-sdg-full@2x.png";
import imgSdg8Full from "../assets/images/icone-sdg/6-sdg-full@2x.png";
import imgSdg9Full from "../assets/images/icone-sdg/7-sdg-full@2x.png";
import imgSdg10Full from "../assets/images/icone-sdg/8-sdg-full@2x.png";
import imgSdg11Full from "../assets/images/icone-sdg/9-sdg-full@2x.png";
import imgSdg12Full from "../assets/images/icone-sdg/10-sdg-full@2x.png";
import imgSdg13Full from "../assets/images/icone-sdg/11-sdg-full@2x.png";
import imgSdg14Full from "../assets/images/icone-sdg/12-sdg-full@2x.png";
import imgSdg15Full from "../assets/images/icone-sdg/13-sdg-full@2x.png";
import imgSdg16Full from "../assets/images/icone-sdg/14-sdg-full@2x.png";
import imgSdg17Full from "../assets/images/icone-sdg/15-sdg-full@2x.png";

import imgSdg3 from "../assets/images/icone-sdg/1-sdg-border@2x.png";
import imgSdg4 from "../assets/images/icone-sdg/2-sdg-border@2x.png";
import imgSdg5 from "../assets/images/icone-sdg/3-sdg-border@2x.png";
import imgSdg6 from "../assets/images/icone-sdg/4-sdg-border@2x.png";
import imgSdg7 from "../assets/images/icone-sdg/5-sdg-border@2x.png";
import imgSdg8 from "../assets/images/icone-sdg/6-sdg-border@2x.png";
import imgSdg9 from "../assets/images/icone-sdg/7-sdg-border@2x.png";
import imgSdg10 from "../assets/images/icone-sdg/8-sdg-border@2x.png";
import imgSdg11 from "../assets/images/icone-sdg/9-sdg-border@2x.png";
import imgSdg12 from "../assets/images/icone-sdg/10-sdg-border@2x.png";
import imgSdg13 from "../assets/images/icone-sdg/11-sdg-border@2x.png";
import imgSdg14 from "../assets/images/icone-sdg/12-sdg-border@2x.png";
import imgSdg15 from "../assets/images/icone-sdg/13-sdg-border@2x.png";
import imgSdg16 from "../assets/images/icone-sdg/14-sdg-border@2x.png";
import imgSdg17 from "../assets/images/icone-sdg/15-sdg-border@2x.png";

import imgContrib1salute from "../assets/images/icone-contributi/cont-01-salute.svg";

import imgContrib1tutela from "../assets/images/icone-contributi/cont-01-tutela.svg";
import imgContrib2tutela from "../assets/images/icone-contributi/cont-02-tutela.svg";
import imgContrib3tutela from "../assets/images/icone-contributi/cont-03-tutela.svg";
import imgContrib2salute from "../assets/images/icone-contributi/cont-02-salute.svg";

import imgArea01 from "../assets/images/icone-aree/tutela-del-clima-01.svg";
import imgArea03 from "../assets/images/icone-aree/consumo-responsabile-01.svg";
import imgArea02 from "../assets/images/icone-aree/pari-opportunita-01.svg";
import imgArea04 from "../assets/images/icone-aree/salute-benessere-01.svg";
import imgArea05 from "../assets/images/icone-aree/crescita-sostenibile-01.svg";

export function getAreaListData(areaValues = store.state.areaValue) {
  const AreaListData = [
    {
      id: 1,
      title: "Tutela del clima",
      subTitle:
        "Per investire nelle energie rinnovabili e implementare politiche ambientali a tutela delle risorse naturali.",
      desc:
        "Investi nelle energie rinnovabili e nelle aziende che implementano politiche ambientali a tutela delle risorse naturali",
      consequences:
        "Il riscaldamento terrestre ha impatti sull’ecosistema, economia e  società. Nel 2018, 62 milioni di persone sono state vittima di fenomeni meteorologici estremi. Secondo la Banca mondiale, i finanziamenti necessari per evitare di superare la soglia dei 2°C si aggirano attorno ai 4.1 trilioni di dollari nei prossimi 15 anni",
      color: "#7da61f",
      selected: true,
      value: 0,
      svgClass: "A",
      icon: imgArea01,
      svgSingleClass: "A-tutela-del-clima",
      contribs: [
        {
          id: 2,
          title: "Riduzione dell’inquinamento",
          icon: imgContrib2tutela,
          text:
            "<strong>" +
            formatInt(
              Math.round(
                0.14565 *
                  (areaValues.filter(v => v.id === 1).length > 0
                    ? Number(areaValues.filter(v => v.id === 1)[0].value) * 1.2
                    : 0)
              )
            ) +
            " Kg</strong> di CO2 risparmiata. Pari al consumo medio di <strong>" +
            formatInt(
              Math.round(
                0.001956605757 *
                  (areaValues.filter(v => v.id === 1).length > 0
                    ? Number(areaValues.filter(v => v.id === 1)[0].value) * 1.2
                    : 0)
              )
            ) +
            "</strong> viaggi in auto da Milano a Roma",
          placeholder:
            "Il risparmio delle emissioni di CO2 viene quantificato in viaggi da Milano a Roma"
        },
        {
          id: 1,
          title: "Acqua risparmiata",
          icon: imgContrib1tutela,
          text:
            "<strong>" +
            formatInt(
              Math.round(
                20.2049042679 *
                  (areaValues.filter(v => v.id === 1).length > 0
                    ? Number(areaValues.filter(v => v.id === 1)[0].value) * 1.2
                    : 0)
              )
            ) +
            " Lt</strong> di acqua risparmiata. Pari a <strong>" +
            formatInt(
              Math.round(
                0.2881865034 *
                  (areaValues.filter(v => v.id === 1).length > 0
                    ? Number(areaValues.filter(v => v.id === 1)[0].value) * 1.2
                    : 0)
              )
            ) +
            "</strong>  docce.",
          placeholder:
            "Il calcolo dell’acqua risparmiata viene quantificato in docce"
        },
        {
          id: 3,
          title: "Gestione dei rifiuti",
          icon: imgContrib3tutela,
          text:
            "<strong>84%</strong> di società che implementano rilevanti programmi per la gestione e riduzione dei rifiuti. <strong>+8%</strong> rispetto al Benchmark",
          placeholder:
            "Presenza di società che implementano programmi per la gestione e riduzione dei rifiuti"
        }
      ],
      sdg: [
        {
          id: 7,
          title: "Energia pulita e accessibile",
          name: "Energia pulita e accessibile",
          icon: imgSdg7Full,
          iconFull: imgSdg7,
          desc:
            "Assicurare a tutti l'accesso a sistemi di energia economici, affidabili, sostenibili e moderni."
        },
        {
          id: 13,
          title: "Agire per il clima ",
          name: "Agire per il clima ",
          icon: imgSdg13Full,
          iconFull: imgSdg13,
          desc:
            "Promuovere azioni, a tutti i livelli, per combattere il cambiamento climatico."
        }
      ]
    },
    {
      id: 3,
      title: "Consumo responsabile",
      subTitle:
        "Per attuare un’economia circolare che rispetta le risorse naturali in linea con la tutela dei mari e della terra.",
      desc:
        "Investi in aziende che attuano un’economia circolare che rispetta le risorse naturali in linea con la tutela dei mari e della terra",
      consequences:
        "A partire dagli anni 50 fino ad oggi sono state prodotte più di 8.3 miliardi di tonnellate di plastica, la maggior parte finita in discariche o dispersa nell’ambiente. Il consumo di combustibili è un altro grave problema: secondo un’analisi, i biocombustibili avanzati riusciranno a coprire appena il 3,5% della domanda dei consumatori nel 2030.",
      selected: true,
      value: 0,
      color: "#c7aa91",
      icon: imgArea03,
      svgClass: "C",
      svgSingleClass: "C-consumo-responsabile",
      contribs: [
        {
          id: 1,
          title: "Acqua risparmiata",
          icon: imgContrib1tconsumo,
          text:
            "<strong>" +
            formatInt(
              Number(
                10.43895 *
                  (areaValues.filter(v => v.id === 3).length > 0
                    ? Number(areaValues.filter(v => v.id === 3)[0].value) * 1.2
                    : 0)
              )
            ) +
            " Lt</strong> di acqua risparmiata. Pari a <strong>" +
            formatInt(
              Math.round(
                0.1491279069 *
                  (areaValues.filter(v => v.id === 3).length > 0
                    ? Number(areaValues.filter(v => v.id === 3)[0].value) * 1.2
                    : 0)
              )
            ) +
            "</strong>  docce.",
          placeholder:
            "Il calcolo dell’acqua risparmiata viene quantificato in docce."
        },
        {
          id: 3,
          title: "Gestione dei rifiuti",
          icon: imgContrib3tconsumo,
          text:
            "<strong>89%</strong> di società che implementano rilevanti programmi per la gestione e riduzione dei rifiuti. <strong>+11%</strong> rispetto al Benchmark",
          placeholder:
            "Presenza di società che implementano programmi per la gestione e riduzione dei rifiuti."
        },
        {
          id: 9,
          title: "Cibo naturale e/o biologico",
          icon: imgContrib9consumo,
          text:
            "<strong>" +
            formatInt(
              Number(
                0.00125 *
                  (areaValues.filter(v => v.id === 1).length > 0
                    ? Number(areaValues.filter(v => v.id === 1)[0].value) * 1.2
                    : 0)
              )
            ) +
            " pasti</strong> di cibo naturale e/o biologico prodotti o distribuiti.",
          placeholder:
            "La quantità di cibo naturale e/o biologico prodotto e distribuito viene quantificato in pasti completi."
        }
        // {
        //   id: 2,
        //   title: "Riduzione dell’inquinamento",
        //   icon: imgContrib2tconsumo,
        //   text:
        //     "<strong>" +
        //     Number(0.14 * Number(store.state.capitalValue)).toFixed(2) +
        //     " Kg</strong> di CO2 risparmiata. Pari al consumo medio di " +
        //     Number(0.001 * Number(store.state.capitalValue)).toFixed(2) +
        //     " viaggi in auto da Milano a Roma"
        // },
      ],
      sdg: [
        {
          id: 12,
          title: "Consumo e produzione responsabili ",
          name: "Consumo e produzione responsabili ",
          icon: imgSdg12Full,
          iconFull: imgSdg12,
          desc: "Garantire modelli sostenibili di produzione e di consumo."
        },
        {
          id: 14,
          title: "La vita sott'Acqua ",
          name: "La vita sott'Acqua ",
          icon: imgSdg14Full,
          iconFull: imgSdg14,
          desc:
            "Conservare e utilizzare in modo durevole gli oceani, i mari e le risorse marine per uno sviluppo sostenibile."
        },
        {
          id: 15,
          title: "La vita sulla terra",
          name: "La vita sulla terra",
          icon: imgSdg15Full,
          iconFull: imgSdg15,
          desc:
            "Proteggere, ripristinare e favorire un uso sostenibile dell'ecosistema terrestre."
        }
      ]
    },
    {
      id: 2,
      title: "Pari opportunità",
      subTitle:
        "Per favorire il rispetto delle pari opportunità, la tutela delle minoranze e l’uguaglianza di genere.",
      desc:
        "Investi in aziende che favoriscono il rispetto delle pari opportunità, la tutela delle minoranze e l’uguaglianza di genere promuovendo una crescita professionale equa.",
      consequences:
        "Le donne guadagnano  il 23% in meno rispetto ad un uomo. Inoltre, l’Italia risulta 118esima in classifica tra i paesi avanzati per le opportunità economiche e lavorative. Per l'educazione: a livello globale 750 milioni di adulti (di cui due terzi solo donne) rimangono analfabeti. In Italia si registra il 18% di laureati contro il 37% di media nella zona OCSE",
      selected: true,
      value: 0,
      icon: imgArea02,
      color: "#ba7d8f",
      svgClass: "B",
      svgSingleClass: "B-pari-opportunita",
      contribs: [
        {
          id: 4,
          title: "Tutela del lavoro minorile",
          icon: imgContrib4pari,
          text:
            "<strong>87%</strong> di società che intraprendono forti azioni contro pratiche di lavoro minorile. <strong>+18%</strong> rispetto al Benchmark",
          placeholder:
            "Presenza di società che implementano forti azioni contro pratiche di lavoro minorile."
        },
        {
          id: 5,
          title: "Uguaglianza di genere",
          icon: imgContrib5,
          text:
            "<strong>28%</strong> di donne nel management e nel consiglio d'amministrazione. <strong>+6%</strong> rispetto al Benchmark",
          placeholder:
            "Maggior numero di donne nei consigli d'amministrazione rispetto al mercato."
        },
        // {
        //   id: 6,
        //   title: "Consiglieri indipendenti",
        //   icon: imgContrib6,
        //   text: "<strong>70%</strong> di consiglieri indipendenti nel Board. "
        // },
        {
          id: 8,
          title: "Anticorruzione",
          icon: imgContrib8pari,
          text:
            "<strong>95%</strong> di società che intraprendono forti azioni contro la corruzione <strong>+9%</strong> rispetto al Benchmark",
          placeholder:
            "Presenza di  società che implementano forti azioni contro la corruzione."
        }
      ],
      sdg: [
        {
          id: 4,
          title: "Istruzione di qualità",
          name: "Istruzione di qualità",
          icon: imgSdg4Full,
          iconFull: imgSdg4,
          desc:
            "Fornire un'educazione di qualità, equa e inclusiva, e opportunità di apprendimento per tutti."
        },
        {
          id: 5,
          title: "Uguaglianza di genere",
          name: "Uguaglianza di genere",
          icon: imgSdg5Full,
          iconFull: imgSdg5,
          desc:
            "Raggiungere l'uguaglianza di genere ed emancipare tutte le donne e le ragazze."
        },
        {
          id: 10,
          title: "Ridurre le disuguaglianze ",
          name: "Ridurre le disuguaglianze ",
          icon: imgSdg10Full,
          iconFull: imgSdg10,
          desc: "Ridurre le disuguaglianze all'interno e fra le nazioni."
        }
      ]
    },
    {
      id: 4,
      title: "Salute e Benessere",
      subTitle:
        "Per investire su salute, alimentazione naturale, prodotti e servizi che favoriscano uno stile di vita attivo e sano.",
      desc:
        "Investi in aziende operative nel campo della salute, alimentazione naturale, prodotti e servizi che favoriscano uno stile di vita attivo e sano",
      consequences:
        "Un rapporto redatto da scienziati ed esperti di 70 Paesi diversi, riporta che entro il 2050 il pianeta sarà abitato da 10 miliardi di persone. Significa che avremo bisogno del 50% in più di cibo e del 50-60% in più d’energia. Il sovraffollamento porta a malnutrizione, diffusione di malattie mortali e problemi sociali che spesso generano conflitti",
      color: "#db5a34",
      value: 0,
      icon: imgArea04,
      selected: true,
      svgClass: "D",
      svgSingleClass: "D-salute-benessere",
      contribs: [
        {
          id: 2,
          title: "Riduzione dell’inquinamento",
          icon: imgContrib2salute,
          text:
            "<strong>" +
            formatInt(
              Math.round(
                0.1 *
                  (areaValues.filter(v => v.id === 4).length > 0
                    ? Number(areaValues.filter(v => v.id === 4)[0].value) * 1.2
                    : 0)
              ).toFixed(0)
            ) +
            " Kg</strong> di CO2 risparmiata. Pari al consumo medio di <strong>" +
            formatInt(
              Math.round(
                0.001 *
                  (areaValues.filter(v => v.id === 4).length > 0
                    ? Number(areaValues.filter(v => v.id === 4)[0].value) * 1.2
                    : 0)
              ).toFixed(0)
            ) +
            "</strong> viaggi in auto da Milano a Roma",
          placeholder:
            "Il risparmio delle emissioni di CO2 viene quantificato in viaggi da Milano a Roma."
        },
        // {
        //   id: 7,
        //   title: "Pazienti a rischio",
        //   icon: imgContrib7salute,
        //   text:
        //     "<strong>2,8</strong> trattamenti specifici forniti. Pari a <strong>1</strong> pazienti a rischio trattati mediante prodotti e servizi offerti."
        // },
        {
          id: 1,
          title: "Acqua risparmiata",
          icon: imgContrib1salute,
          text:
            "<strong>" +
            formatInt(
              Math.round(
                9.384 *
                  (areaValues.filter(v => v.id === 4).length > 0
                    ? Number(areaValues.filter(v => v.id === 4)[0].value) * 1.2
                    : 0)
              ).toFixed(0)
            ) +
            " Lt</strong> di acqua risparmiata. Pari a <strong>" +
            formatInt(
              Math.round(
                0.134057430697057 *
                  (areaValues.filter(v => v.id === 4).length > 0
                    ? Number(areaValues.filter(v => v.id === 4)[0].value) * 1.2
                    : 0)
              ).toFixed(0)
            ) +
            "</strong> docce.",
          placeholder:
            "Il calcolo dell’acqua risparmiata viene quantificato in docce."
        },
        {
          id: 9,
          title: "Cibo naturale e/o biologico",
          icon: imgContrib9,
          text:
            "<strong>" +
            formatInt(
              Number(
                0.001048568939 *
                  (areaValues.filter(v => v.id === 4).length > 0
                    ? Number(areaValues.filter(v => v.id === 4)[0].value) * 1.2
                    : 0)
              ).toFixed(0)
            ) +
            " pasti</strong> di cibo naturale e/o biologico prodotto e distribuito.",
          placeholder:
            "La quantità di cibo naturale e/o biologico prodotto e distribuito viene quantificato in pasti completi."
        }
        // {
        //   id: 9,
        //   title: "Alimentazione sana",
        //   icon: imgContrib9,
        //   text:
        //     "<strong>" +
        //     Number(0.0023 * Number(store.state.capitalValue)).toFixed(2) +
        //     " pasti</strong> di cibo naturale e/o biologico prodotto e distribuito."
        // },
        // {
        //   id: 10,
        //   title: "Ambiente di lavoro",
        //   icon: imgContrib10salute,
        //   text:
        //     "<strong>61%</strong> di società che presentano un elevato livello di soddisfazione dei Dipendenti <strong>+24%</strong> rispetto al Benchmark"
        // }
      ],
      sdg: [
        {
          id: 3,
          title: "Salute e Benessere",
          name: "Salute e Benessere",
          icon: imgSdg3Full,
          iconFull: imgSdg3,
          desc:
            "Assicurare la salute e il benessere per tutti e per tutte le età."
        },
        {
          id: 6,
          title: "Acqua pulita e igiene",
          name: "Acqua pulita e igiene",
          icon: imgSdg6Full,
          iconFull: imgSdg6,
          desc:
            "Garantire a tutti la disponibilità e la gestione sostenibile dell'acqua e delle strutture igienico-sanitarie."
        },
        {
          id: 11,
          title: "Città e comunità sostenibili  ",
          name: "Città e comunità sostenibili  ",
          icon: imgSdg11Full,
          iconFull: imgSdg11,
          desc:
            "Rendere la città e gli insediamenti umani inclusivi, sicuri, duraturi e sostenibili."
        }
      ]
    },
    {
      id: 5,
      title: "Crescita sostenibile",
      subTitle:
        "Per promuovere le “città intelligenti”, connotate da sviluppo tecnologico, rispetto dell’ambiente e della forza lavoro.",
      desc:
        "Investi favorendo aziende con elevato potenziale di crescita e innovazione che operano in ambiti infrastrutturali per migliorare la qualità della vita nelle città e applicano solide politiche di rispetto della forza lavoro e riduzione dell’inquinamento.",
      consequences:
        "Sicuramente la crescita ha portato enormi vantaggi all'umanità ma negli ultimi 20-30 anni è stata caratterizzata da diseguaglianze sociali, da problemi connessi alla povertà e ha portato più instabilità nel sistema, prova ne è la recente recessione. La disoccupazione rimane una criticità del nostro paese, nel 2018 davanti solo a Grecia e Spagna",
      selected: true,
      color: "#296093",
      value: 0,
      icon: imgArea05,
      svgClass: "E",
      svgSingleClass: "E-crescita-sostenibile",
      contribs: [
        // {
        //   id: 7,
        //   title: "Pazienti a rischio",
        //   icon: imgContrib7crescita,
        //   text:
        //     "<strong>2,8</strong> trattamenti specifici forniti. Pari a <strong>1</strong> pazienti a rischio trattati mediante prodotti e servizi offerti."
        // },
        {
          id: 10,
          title: "Ambiente di lavoro",
          icon: imgContrib10crescita,
          text:
            "<strong>63%</strong> di società che presentano un elevato livello di soddisfazione dei Dipendenti <strong>+24%</strong> rispetto al Benchmark",
          placeholder:
            "Presenza di società che garantiscono un elevato livello di soddisfazione dei dipendenti."
        },
        {
          id: 4,
          title: "Tutela del lavoro minorile",
          icon: imgContrib4crescita,
          text:
            "<strong>85%</strong> di società che intraprendono forti azioni contro pratiche di lavoro minorile. <strong>+17%</strong> rispetto al Benchmark",
          placeholder:
            "Presenza di società che implementano forti azioni contro pratiche di lavoro minorile."
        },
        {
          id: 8,
          title: "Anticorruzione",
          icon: imgContrib8crescita,
          text:
            "<strong>93%</strong> di società che intraprendono forti azioni contro la corruzione <strong>+7%</strong> rispetto al Benchmark",
          placeholder:
            "Presenza di società che implementano forti azioni contro la corruzione."
        }
      ],
      sdg: [
        {
          id: 8,
          title: "Lavoro dignitoso e crescita economica",
          name: "Lavoro dignitoso e crescita economica",
          icon: imgSdg8Full,
          iconFull: imgSdg8,
          desc:
            "Incentivare una crescita economica duratura, inclusiva e sostenibile, un'occupazione piena e produttiva ed un lavoro dignitoso per tutti."
        },
        {
          id: 9,
          title: "Industria innovazione e infrastrutture",
          name: "Industria innovazione e infrastrutture",
          icon: imgSdg9Full,
          iconFull: imgSdg9,
          desc:
            "Costruire un'infrastruttura resiliente e promuovere l'innovazione ed una industrializzazione equa, responsabile e sostenibile."
        },
        {
          id: 16,
          title: "Pace, giustizia e istituzioni forti",
          name: "Pace, giustizia e istituzioni forti",
          icon: imgSdg16Full,
          iconFull: imgSdg16,
          desc:
            "Promuovere società pacifiche e più inclusive per uno sviluppo sostenibile; offrire l'accesso alla giustizia per tutti."
        },
        {
          id: 17,
          title: "Partnership per gli obiettivi",
          name: "Partnership per gli obiettivi",
          icon: imgSdg17Full,
          iconFull: imgSdg17,
          desc:
            "Rafforzare i mezzi di attuazione e rinnovare il paternariato mondiale per lo sviluppo sostenibile."
        }
      ]
    }
  ];
  return AreaListData;
}

// function formatDecimal(num) {
//   return num
//     .toFixed(2) // always two decimal digits
//     .replace(".", ",") // replace decimal point character with ,
//     .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1."); // use . as a separator
// }
function formatInt(num) {
  num = parseInt(num);
  return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1."); // use . as a separator
}
